import { render, staticRenderFns } from "./AFA.vue?vue&type=template&id=39798f4b&"
import script from "./AFA.vue?vue&type=script&lang=js&"
export * from "./AFA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports